import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import upload from 'App/helpers/fields/upload'
import { FaFileImage, FaCamera } from 'react-icons/fa'
import CameraComponent from './Camera'

const DocumentUploadField = ({ onChange, value, title, headers, cameraOverlay, fieldName }) => {
  const [showCamera, setShowCamera] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [fileName, setFileName] = useState('')
  const [imagePreview, setImagePreview] = useState('')

  const handleFileUpload = async file => {
    setLoading(true)
    setError(false)
    try {
      const up = await upload(file)
      setFileName(file.name)
      setLoading(false)
      setImagePreview(URL.createObjectURL(file))
      onChange &&
        onChange({
          file,
          s3Url: up.url,
          s3Path: up.meta.s3Path,
          awsKey: up.meta.awsKey,
        })
    } catch (e) {
      setLoading(false)
      setFileName('Error!')
      setError(true)
      console.error(e)
    }
  }

  const handleInputUpload = () => {
    const input = document.createElement('input')
    input.type = 'file'
    input.onchange = async e => {
      const file = e.target.files[0]
      handleFileUpload(file)
    }
    input.click()
  }

  const renderCardState = () => {
    if (error) return 'Error intenta nuevamente'
    if (loading) return 'Cargando...'
    if (!value) return 'Subir Imagen'
    return 'Imagen preparada'
  }

  const getCardStateColor = () => {
    if (error) return { borderColor: '#f44336' }
    if (loading) return { borderColor: '#D0D0D0' }
    if (!value) return { borderColor: '#D0D0D0' }
    return { borderColor: '#0069ff' }
  }

  const renderFileAttach = () => {
    return (
      <div
        onClick={handleInputUpload}
        className={styles.documentContainerBig}
        style={getCardStateColor()}>
        {imagePreview ? (
          <div className={styles.previewMiniContainer}>
            <img alt="preview" src={imagePreview} />
          </div>
        ) : (
          <div className={styles.iconContainer}>
            <FaFileImage size="30" color="#0e67f6" />
          </div>
        )}
        <div className={styles.cardText}>
          <p>{renderCardState()}</p>
        </div>
      </div>
    )
  }

  const toggleCamera = () => {
    setShowCamera(!showCamera)
  }

  const renderCameraAttach = () => {
    return (
      <div>
        <div onClick={toggleCamera} className={styles.cameraCard} style={getCardStateColor()}>
          <div className={styles.cameraIconContainer}>
            <FaCamera size="30" color="#0e67f6" />
          </div>
          <div className={styles.takePicture} />
        </div>
      </div>
    )
  }

  const renderCamera = () => {
    if (!showCamera) return null
    return (
      <CameraComponent
        onChange={handleFileUpload}
        onClose={toggleCamera}
        overlay={cameraOverlay}
        fieldName={fieldName}
      />
    )
  }

  return (
    <div>
      <div className={styles.boxDescriptionContainer}>
        <h4 className="tds-orionx-font-dm__subtitle">{title}</h4>
        {headers.map((value, index) => (
          <p key={index} className="block tds-orionx-font-dm__body-small">
            {value}
          </p>
        ))}
      </div>
      {renderFileAttach()}
      {renderCameraAttach()}
      <p className={styles.fileText}>{fileName || ''}</p>
      {renderCamera()}
    </div>
  )
}

DocumentUploadField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  title: PropTypes.string,
  headers: PropTypes.array,
  cameraOverlay: PropTypes.string,
  fieldName: PropTypes.string,
}

export default DocumentUploadField
